import React, { useContext, useState } from 'react';
import image from "./logo.png";
import car from "./car.png";
import GlobalContext from '../connections/GlobalContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";


const Login = () => {
  const [submit, setSubmit] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { globalValue } = useContext(GlobalContext);
  const navigate = useNavigate();


  const user_submit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${globalValue}/login`, {
        username,
        password,
      });

      console.log(response.data);

      if (response.data.message === "success") {
        setSubmit(true);

        sessionStorage.setItem("name", username);
        sessionStorage.setItem("position", response.data.position)
        sessionStorage.setItem("branch", response.data.branch)
        sessionStorage.setItem("token", response.data.token)
        setTimeout(() => {
          if (response.data.position === "superadmin") {
            navigate("/dashboard")
          }
          else if (response.data.position === "admin") {
            navigate("/staff")
          }
          else if (response.data.position === "staff") {
            navigate("/estimate_data")
          }
        }, 1200);
      } else {
        console.log(response.data);
        Swal.fire({
          icon: "error",
          title: "Login Failed",
          text: "Invalid username or password. Please try again!",
        });
      }
    } catch (error) {
      console.error("Error during login:", error);


      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An unexpected error occurred. Please try again later.",
      });
    }
  };

  return (
    <div>
      <div className="back w-full h-screen flex items-center justify-center relative overflow-hidden">
        <div className="absolute w-[400px] h-[400px] rounded-[50%] bg-gray-200 top-[-200px] left-[-200px] blur-sm opacity-30"></div>
        <div className="box w-full mx-2 md:w-[800px] h-[550px] md:ms-0 bg-white rounded-xl shadow-xl flex z-50 relative">


          <div className={`hidden md:block car-container absolute bottom-8 left-16 ${submit ? 'animate-car' : ''}`}>
            <img
              src={car}
              className="w-36 h-16 relative"
              alt="car"
            />
            {submit && (
              <div className="absolute -bottom-3 left-8 space-x-2 flex">

                {[...Array(5)].map((_, i) => (
                  <div
                    key={i}
                    className="exhaust w-2 h-2 bg-gray-600 rounded-full animate-exhaust"
                    style={{ animationDelay: `${i * 0.2}s` }}
                  ></div>
                ))}
              </div>
            )}
          </div>


          <div className="hidden md:block rounded-l-xl h-full w-[35%] bg-gray-300 flex items-center relative">
            <img src={image} className="mt-16" alt="logo" />
            <div className="w-full absolute flex flex-col items-center bottom-10">
              <p className='text-[10px] text-gray-700'>© Copyright Jals Auto Mobiles . All Rights Reserved</p>
              <div className="flex"><p className='text-[13px]'> Designed by </p><p className='text-[13px] ms-1 hover:underline hover:text-blue-400'> DCE Technology</p></div>
            </div>
          </div>


          <form onSubmit={user_submit} className="relative rounded-r-xl rounded-l-xl md:rounded-l-0 h-full md:w-[65%] w-full  flex flex-col items-center justify-ce space-y-6 p-6">
            <p className='text-3xl font-bold mt-10'>Jals Auto Mobiles</p>
            <p className='text-2xl text-blue-600'>Welcome Back!</p>
            <div className="w-full ">
              <label htmlFor="username" className="block text-sm font-semibold text-gray-700">Mobile Number</label>
              <input
                id="username"
                type="text"
                className="w-full bg-transparent border-b-2 border-gray-300 focus:border-blue-500 py-2 px-3 mt-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter your mobile number"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="w-full ">
              <label htmlFor="password" className="block text-sm font-semibold text-gray-700">Password</label>
              <input
                id="password"
                type="password"
                className="w-full bg-transparent border-b-2 border-gray-300 focus:border-blue-500 py-2 px-3 mt-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>


            <div className="relative inline-block  p-[4px] rounded-3xl bg-gradient-to-r from-red-500 via-yellow-500 via-green-500 via-teal-500 via-blue-500 via-indigo-500 to-purple-500 animate-gradient-move">
              <button
                className="relative bg-white text-black px-24 md:px-48 py-2 flex rounded-3xl focus:outline-none font-bold text-xl"
                type="submit"
              >
                Sign In
              </button>
            </div>
            <div className=" w-full absolute md:hidden flex flex-col items-center bottom-10">
              <p className='text-[10px] text-gray-700'>© Copyright Jals Auto Mobiles . All Rights Reserved</p>
              <div className="flex"><p className='text-[13px]'> Designed by </p><p className='text-[13px] ms-1 hover:underline hover:text-blue-400'> DCE Technology</p></div></div>
          </form>

        </div>
      </div>


      <style>{`
        @tailwind base;
        @tailwind components;
        @tailwind utilities;

        @keyframes move-car {
          0% { transform: translateX(0); }
          100% { transform: translateX(500px); }
        }

        @keyframes exhaust {
          0% { opacity: 1; transform: scale(1) translateY(0); }
          50% { opacity: 0.5; transform: scale(1.5) translateY(-10px); }
          100% { opacity: 0; transform: scale(2) translateY(-20px); }
        }
        .animate-car {
          animation: move-car 1s linear forwards;
        }

        .animate-exhaust {
          animation: exhaust 0.5s ease-out infinite;
        }
      `}</style>
    </div>
  );
};

export default Login;
